import {useQuery} from 'react-query';
import {getProfile} from '../../../profile';
import {useAuth} from '../../../../context/authContext';

const useGetProfile = (guid?: string) => {
  const {update} = useAuth();
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['userProfile', guid],
    queryFn: () => getProfile(),
    enabled: guid ? true : false,
    onSuccess: data => {
      update(data as IProfile);
    },
  });
  return {data, isLoading, refetch};
};

export default useGetProfile;
